module.exports = __webpack_public_path__ + "static/wild-side-6320d6c72e5873d65b2a467dc8534907.jpg";